var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "headerBig" } }, [
    _c("div", { attrs: { id: "headerSma" } }, [
      _c("div", { staticClass: "content" }, [
        _c("span", { staticClass: "logo", on: { click: _vm.toIndex } }, [
          _c("img", { attrs: { src: _vm.logoIcon } })
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "navs" },
          _vm._l(_vm.nav, function(el, index) {
            return _c(
              "span",
              {
                staticClass: "navSpan",
                class: _vm.navNum == index ? "current" : ""
              },
              [_c("a", { attrs: { href: el.url } }, [_vm._v(_vm._s(el.name))])]
            )
          })
        )
      ]),
      _vm._v(" "),
      _vm.isShow
        ? _c("div", { staticClass: "search-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword"
                }
              ],
              staticClass: "search-inp",
              attrs: { type: "text", placeholder: "请输入关键词" },
              domProps: { value: _vm.keyword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.keyword = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                class: _vm.keyword ? "search-btn" : "search-btn disabled",
                on: { click: _vm.toSearchPage }
              },
              [_vm._v("搜索")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.userInfo.userId
        ? _c("div", { staticClass: "userBox" }, [
            _c("div", { staticClass: "user-content" }, [
              !_vm.userInfo.userId
                ? _c("span", { staticClass: "noLogin register" }, [
                    _c("a", { attrs: { href: _vm.registerUrl } }, [
                      _vm._v("注册")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.userInfo.userId
                ? _c("span", { staticClass: "noLogin login" }, [
                    _c("a", { attrs: { href: _vm.loginUrl } }, [_vm._v("登录")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", {
                staticClass: "noLogin search-icon",
                on: { click: _vm.toggleSearchBox }
              })
            ])
          ])
        : _c(
            "div",
            {
              staticClass: "userBox",
              class: _vm.userInfo.userId ? "isLogin" : ""
            },
            [
              _c("span", {
                staticClass: "search-icon-login",
                on: { click: _vm.toggleSearchBox }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "name",
                  attrs: { title: _vm.userInfo.nickName },
                  on: { click: _vm.changeToggle }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.userInfo.nickName) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "toggle-icon",
                class: !_vm.isToggle ? "" : "reverse",
                on: { click: _vm.changeToggle }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "user-img",
                attrs: { src: _vm.userInfo.userImg, alt: "" },
                on: { click: _vm.toUindex }
              }),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.isToggle
                  ? _c(
                      "div",
                      {
                        staticClass: "user-operate",
                        on: { mouseleave: _vm.changeToggle }
                      },
                      [
                        _c("li", { on: { click: _vm.toUindex } }, [
                          _c("span", { staticClass: "user-icon" }, [
                            _c("img", { attrs: { src: _vm.userIcon } })
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "user-msg" }, [
                            _vm._v("用户中心")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", { on: { click: _vm.logout } }, [
                          _c("span", { staticClass: "logout-icon" }, [
                            _c("img", { attrs: { src: _vm.logoutIcon } })
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "logout-msg" }, [
                            _vm._v("退出登录")
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d9b6fb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d9b6fb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 24
// module chunks = 0